import * as yup from 'yup';

export const account_closure_schema = {
  reasonClosure: '',
  is_authorized: false,
};

export const account_closure_validation_schema = yup.object().shape({
  reasonClosure: yup.string().required('reasonClosure_is_required'),
  is_authorized: yup
    .boolean()
    .oneOf([true], 'authorization_required'),
});
